import { React, useEffect, useState } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  createChapter,
  getChapter,
  resetState,
  updateChapter,
} from "../features/chapters/chapterslice";
let schema = yup.object().shape({
  name: yup.string().required("Name is Required"),
  post: yup.string().required("Post is Required"),
  email: yup.string().required("Email is Required"),
  phone: yup.string().required("Phone is Required"),
  location: yup.string().required("Location is Required"),
  image: yup.mixed().required("Image is Required"),
});
const AddNewscat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsCatId = location.pathname.split("/")[3];
  const newNewsCategory = useSelector((state) => state.chapter);
  const [imageErrorone, setImageErrorone] = useState("");
    const {
    isSuccess,
    isError,
    isLoading,
    createdChapter,
    updatedChapter,
    chaptersname,
    chapterspost,
    chaptersemail,
    chaptersphone,
    chapterslocation
  } = newNewsCategory;
  const token = useSelector((state) => state.autht.token);
  useEffect(() => {
    if (getNewsCatId !== undefined) {
      dispatch(getChapter(getNewsCatId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsCatId]);
  useEffect(() => {
    if (isSuccess && createdChapter) {
      toast.success("Chapter Added Successfullly!");
      navigate("/association/Chapters-list");
    }
    if (isSuccess && updatedChapter) {
      toast.success("Chapter Updated Successfullly!");
      navigate("/association/Chapters-list");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: chaptersname|| "",
      post:chapterspost||"",
      email: chaptersemail|| "",
      phone: chaptersphone||"",
      location:chapterslocation|| "",
      image: null,
      token: token
    },
    validationSchema: schema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("post", values.post);
      formData.append("email", values.email);
      formData.append("phone", values.phone);
      formData.append("location", values.location);
      formData.append("image", values.image);
      formData.append("token",token);
      formData.append("id",getNewsCatId);
     console.log(formData);
      if (getNewsCatId !== undefined) {
        dispatch(updateChapter(formData));
        dispatch(resetState());
      } else {
        dispatch(createChapter(formData));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });

  return (
    <div>
      <h3 className="mb-4  title">
        {getNewsCatId !== undefined ? "Edit" : "Add"} chapter
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <CustomInput
            type="text"
            name="name"
            onChng={formik.handleChange("name")}
            onBlr={formik.handleBlur("name")}
            val={formik.values.name}
            label="Enter Name"
          />
          <div className="error">
            {formik.touched.name && formik.errors.name}
          </div>


          <CustomInput
            type="text"
            label="Enter Post"
            name="post"
            onChng={formik.handleChange("post")}
            onBlr={formik.handleBlur("post")}
            val={formik.values.post}
          />
          <div className="error">{formik.touched.post && formik.errors.post}</div>



          <CustomInput
            type="text"
            label="Enter Email"
            name="email"
            onChng={formik.handleChange("email")}
            onBlr={formik.handleBlur("email")}
            val={formik.values.email}
          />
          <div className="error">{formik.touched.email && formik.errors.email}</div>



          <CustomInput
            type="text"
            label="Enter Phone"
            name="phone"
            onChng={formik.handleChange("phone")}
            onBlr={formik.handleBlur("phone")}
            val={formik.values.phone}
          />
          <div className="error">{formik.touched.phone && formik.errors.phone}</div>


          <CustomInput
            type="text"
            label="Enter Location"
            name="country"
            onChng={formik.handleChange("location")}
            onBlr={formik.handleBlur("location")}
            val={formik.values.location}
          />
          <div className="error">{formik.touched.location && formik.errors.location}</div>


          <div className="mt-4">
            <label htmlFor="image" className="form-label">Select Home Image file</label>
            <input
              type="file"
              id="image"
              name="image"
              accept="image/*"
              onChange={(e) => {
                formik.setFieldValue("image", e.currentTarget.files[0]);
                setImageErrorone(""); // Clear image error when a new file is selected
              }}
              className="form-control"
            />
            <div className="error">{formik.touched.image && formik.errors.image}</div>
          </div>
          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
            disabled={isLoading}
          >
            {isLoading && (
              <div className="loader"></div>
            )}
            {isLoading ? "" : getNewsCatId !== undefined ? "Edit" : "Add"} chapter
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNewscat;
